<template>
  <v-navigation-drawer
    v-model="show"
    v-lock-scroll="show"
    app
    temporary
    :stateless="true"
    right
    width="800px"
  >
    <close-panel-button
      @close="() => show = false"
      text="My inventory"
    />

    <v-container class="px-10 py-0" v-if="kit">
      <v-row>
        <v-col cols="12">
          <h2 class="f40 lato-light font-weight-light">
            Assign tags to {{ kit.product.name }}
          </h2>
        </v-col>
        <v-col cols="12">
          <v-divider class="mt-2 mb-5 mr-10" />
        </v-col>
        <v-col cols="6">
          <kit-images-grid :products="kit.product.kit.products" />
        </v-col>
        <v-col cols="12">
          <v-divider class="mt-2 mb-5 mr-10" />
        </v-col>
        <v-col cols="12">
          <div class="kit-tags-panel__tags-wrapper">
            <div class="kit-tags-panel__tags-label">
              <span>Tags</span> (assigned groups)
            </div>
            <select-multiple-entities
              id="tags-access"
              v-model="userTags"
              :items="tagsList"
              placeholder="Select tags"
              item-text="name"
              item-value="id"
              :height="40"
              clearable
              chips
            />
          </div>
        </v-col>
        <v-col cols="12">
          <cg-button @click="saveChanges" :loading="saving">
            Save changes
          </cg-button>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { CgButton } from '@corporategiftcom/design-system'
import inventoryService from '@/services/myInventory/inventoryService'
import panelShow from './mixins/panelShow'
import SelectMultipleEntities from "@/components/mySubAccounts/SelectMultipleEntities.vue";
import InventoryKitImagesGrid from '../InventoryKitImagesGrid.vue'

export default {
  name: 'KitTagsPanel',
  components: {
    SelectMultipleEntities,
    KitImagesGrid: InventoryKitImagesGrid,
    CgButton
  },
  mixins: [
    panelShow,
  ],
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    kit: {
      type: Object,
      required: false
    },
  },
  data: () => ({
    saving: false,
    userTags: [],
  }),
  computed: {
    tagsList() { return this.$store.state.inventory.tags ?? [] },
  },
  watch: {
    show (val) {
      if (val) {
        this.userTags = (this.kit?.product?.tags ?? []).map(tag => tag.id)
      }
    }
  },
  methods: {
    async saveChanges () {
      this.saving = true
      try {
        await inventoryService.saveItemTags(this.kit.product.item_id, this.userTags)
        this.show = false
        this.$emit('fetchInventoryList')
      } catch {
        this.$cgToast.error('An unexpected error occurred, please try again later')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.kit-tags-panel {
  &__tags-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__tags-label {
    display: flex;
    gap: 5px;
    color: #222325;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    span {
      font-weight: 700;
    }
  }
}
</style>
